module.exports = __webpack_public_path__ + "static/img/footer-menu-icon05.b90160b7.svg";